import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Remove Cloudflare navigation-tracking noise while preserving any genuine query parameters.
const url = new URL(window.location.href);
if (url.searchParams.has('cf_target_id')) {
  url.searchParams.delete('cf_target_id');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
